import React , {useContext} from "react";
import './Services.css';
import IndustrialDesign from '../../assets/tresdmodeling.png'
import SoftwareDevelopment from '../../assets/code.png'
import GraphicDesign from '../../assets/pincel.png'
import Card from "../card/Card";
//import CV from './CV.pdf';
import CV2024 from './CV2024OK.pdf';
import { themeContext } from "../../Context";
import {motion} from 'framer-motion';
import { useTranslation } from "react-i18next";


const Services = () => {
    const [t] = useTranslation("global");

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;

    return(
        <div className="services" id="Services">
         {/* ----------------------------------------------------------------- left side - services and skills */}
            <div className="awesome">
            
                <span>{t("Services.title.1")}</span>
                <span style={{color : darkMode? 'white' : ''}}>{t("Services.title.2")}</span>
                <span>{t("Services.title.3")}</span>

                <span style={{color : darkMode? '#ffcd6a' : ''}}>
                     {t("Services.description.1")}
                    <br/>
                     {t("Services.description.2")}
                    <br/>
                     {t("Services.description.3")}
                    <br/>
                    
                </span>

                <a href={CV2024} download >
                <button  className="button s-button">
                   {t("Services.download")}
                </button>
                </a>



                <div className="blur" style={{backgroundColor:"rgb(238 210 255)"}} ></div>
                
            </div>
           {/*  --------------------------------------------------------------------rights side cards */}
            <div className="cards">

              {/*   first card */}
                <motion.div 
                    initial={{opacity:0, x: -30, y:50}}
                    whileInView={{opacity:1,  x:5 , y:2}}
                    transition={{
                    default: {type: "spring", damping: 10, duration: 2, stiffness: 40, ease: [0.5, 0.71, 0.2, 1.5] }, }}
                    className="csd" style={{left: '6rem'}}>
                    <Card
                     photo = {SoftwareDevelopment}
                     heading = {t("Services.cards.sd.1")}
                     detail = {t("Services.cards.sd.2")}
                     >
                    </Card>
                </motion.div>

               {/*   Second card: IndustrialDesign */}
                 <motion.div 
                  initial={{opacity:0, x: -30, y:-50}}
                  whileInView={{opacity:1,  x:5, y:2 }}
                  transition={{
                  default: {type: "spring", damping: 10, duration: 2, stiffness: 40, ease: [0.5, 0.71, 0.2, 1.5] }, }}
                  className="cid" style={{left: '22rem'}}>
                    <Card
                     photo = {IndustrialDesign}
                     heading = {t("Services.cards.id.1")}
                     detail = {t("Services.cards.id.2")}
                     >
                    </Card>
                </motion.div>

             {/*  Third card: graphic Design */}
                <motion.div 
                  initial={{opacity:0, x: 80}}
                  whileInView={{opacity:1,  x:5 }}
                  transition={{
                  default: {type: "spring", damping: 10, duration: 2, stiffness: 40, ease: [0.5, 0.71, 0.2, 1.5] }, }}
                  className="cgd" style={{left: '14rem', top: '18rem'}}>
                    <Card
                     photo = {GraphicDesign}
                     heading = {t("Services.cards.gd.1")}
                     detail = {t("Services.cards.gd.2")}
                     >
                    </Card>
                </motion.div>

                <div className="blur s-blur2" style={{background:"var(--purple)"}} ></div>

            </div>

        </div>
    );
}

export default Services;